@if (canShowPurchaseOrderPanel) {
  <purchase-order-panel (closePanelEvent)="fnClosePurchaseOrderPanel()"></purchase-order-panel>
} @else {
  <ds-modal [modalInput]="modalConfig">
    <ng-container class="modal-content-wrapper" modal-body>
      @if (!isDemoBooked) {
        <p>{{ 'new_onb_trial_over_line1' | translate:{ days: (basicFunctionTrialDays ?? 0) } }}</p>
        <p>{{ 'new_onb_trial_account_active' | translate }} <span class="text-error">{{ 'new_onb_permanently_deleted' | translate }}</span>.</p>
      } @else {
        <p>{{ 'new_onb_demo_sent_pre' | translate }} <b>{{ 'new_onb_contact_you' | translate }}</b> {{ 'new_onb_demo_sent_post' | translate }}</p>
      }
    </ng-container>
    <ng-container modal-footer>
      @if (!isDemoBooked) {
        <ds-button [buttonInput]="requestDemoButton" (btnClick)="fnOpenCalendlyModal()"></ds-button>
      } @else {
        <ds-button [buttonInput]="logoutButton" (btnClick)="fnLogout()"></ds-button>
      }
    </ng-container>
  </ds-modal>

  <ds-modal [modalInput]="calendlyModalConfig" (visibleChange)="onCalendlyModalVisibleChange($event)">
    <ng-container modal-body>
      <div class="heightCalc-10">
            <iframe [src]="safeCalendlyUrl"
              width="100%"
              height="100%"
              frameborder="0"
              style="border: 0"
              allowfullscreen>
            </iframe>
      </div>
    </ng-container>
    <ng-container modal-footer>
      <ds-button [buttonInput]="calendlyConfirmButtonConfig" (btnClick)="fnConfirmDemoRequest()"></ds-button>
    </ng-container>
  </ds-modal>
}
